export default "__VITE_ASSET__f7b224d7__"